import React from "react";
import { InteractionProperty } from "../../models/InteractionProperty";

export default function PiNumberProperty(props: {
  interactionProperty: InteractionProperty;
  onChange: (interactionProperty: any) => void;
  disabled?: boolean;
}) {
  const label = (
    <div className="flex-1 font-poppins text-[13px] font-medium leading-[20px] text-creator-text-sub">
      {props.interactionProperty.name}
    </div>
  );

  const onInputChange = (e: string) => {
    const number = Number(e);
    if (!isNaN(number)) {
      props.onChange({ ...props.interactionProperty, value: number });
    }
  };

  const input = (
    <div className="w-[32px]">
      <input
        type="number"
        value={props.interactionProperty.value as number}
        disabled={props.disabled}
        onChange={(e) => onInputChange(e.currentTarget.value)}
        className={
          "w-[30px] border-0 border-b-2 border-solid bg-transparent text-right font-poppins text-[14px] font-normal leading-[20px] [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none " +
          (props.disabled
            ? "cursor-not-allowed border-b-creator-border text-creator-text-faded"
            : "border-b-creator-primary-disabled focus:border-0 focus:border-b-2 focus:border-solid focus:border-b-creator-primary focus:font-medium focus:outline-none")
        }
      />
    </div>
  );

  return (
    <div className="flex h-[38px] w-full items-center">
      {label} {input}
    </div>
  );
}
